export const captainQueryKeys = {
  all: ["captain"] as const,
  conversations: () => [...captainQueryKeys.all, "conversations"] as const,
  conversation: (id: string) =>
    [...captainQueryKeys.all, "conversation", id] as const,
  models: () => [...captainQueryKeys.all, "models"] as const,
};
